export default __webpack_public_path__ + "static/media/cover10.0a681675.jpg";